// http://kazupon.github.io/vue-i18n/en/messages.html

// const requireLang = require.context(
//   '@/lang',
//   true,
//   /\.json$/
// )

//! MB: non ho capito come funziona il resto quindi per ora la faccio semplice
const messages = {
  en: {
    instance: 'checklist',
    master: 'model',
    message: {
      login: 'Login',
      username: 'Username',
      password: 'Password',
      authenticated: 'Authenticated',
    },
    workspace: 'workspace',
    workspaceUserAccess: {
      admin: 'Shared',
      private: 'Private',
      member: 'Invited',
    },
  },
}

// for (const file of requireLang.keys()) {
//   if (file === './index.js') continue

//   const path = file.replace(/(\.\/|\.json$)/g, '').split('/')

//   path.reduce((o, s, i) => {
//     if (o[s]) return o[s]

//     o[s] = i + 1 === path.length
//       ? requireLang(file)
//       : {}

//     return o[s]
//   }, messages)
// }

export default messages
